// eslint-disable-next-line
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../pages/Home/HomePage';
import PythonPage from '../pages/AI_Section/PythonPage';
import AIPage from '../pages/AI_Section/AIPage';
import MLPage from '../pages/AI_Section/MLPage';
import DataSciencePage from '../pages/AI_Section/DataSciencePage';
import CADCustomizationPage from '../pages/CAD_Home/CADCustomizationPage';
import CADAutomationPage from '../pages/CAD_Home/CADAutomationPage';
import NXOpenCoursePage from '../pages/Courses/NXOpenCoursePage';
import CatiaCAACoursePage from '../pages/Courses/CatiaCAACoursePage';
import CatiaPythonCoursePage from '../pages/Courses/CatiaPythonCoursePage';
import CreoToolKitPage from '../pages/Courses/CreoToolKitPage';
import SolidWorkAPIPage from '../pages/Courses/SolidWorkAPIPage';
import AutoCADNetApiPage from '../pages/Courses/AutoCADNetApiPage';
import RevitAPIPage from '../pages/Courses/RevitAPIPage';
import InventorAPIPage from '../pages/Courses/InventorAPIPage';
import TeamcenterPage from '../pages/Courses/TeamcenterPage';
import WindChillPage from '../pages/Courses/WindChillPage';
import GetInTouch from '../components/common/Contact/GetInTouch';
import PrivacyPolicyPage from '../pages/Home/PrivacyPolicyPage';
import TermsAndConditionsPage from '../pages/Home/TermsAndConditionsPage';
import AICoursePage from '../pages/AI_Section/AICoursePage';
import RAGProjectPage from '../pages/AiProject/RAGProjectPage';
import ITSupportAgenticAIProjectPage from '../pages/AiProject/ITSupportAgenticAIProjectPage';
import BrainStrokePredictionProjectPage from '../pages/AiProject/BrainStrokePredictionProjectPage';
import ImageClassificationProjectPage from '../pages/AiProject/ImageClassificationProjectPage';
import IntelligentManufacturingQualityControlPage from '../pages/AiProject/IntelligentManufacturingQualityControlPage';
import FeesStructure from '../pages/Home/FeesStructure';
import AboutPage from '../pages/Home/AboutPage';
import SEOPage from '../pages/Home/SEOPage';
import ThankYouPage from '../pages/Home/ThankYouPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/contact" element={<GetInTouch />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-conditions" element={<TermsAndConditionsPage />} />
      <Route path="/fees-structure" element={<FeesStructure />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/seo" element={<SEOPage />} />
      <Route path="/thankyou" element={<ThankYouPage />} />


      <Route path="/python-courses-pay-after-learn" element={<PythonPage />} />
      <Route path="/ai-courses-pay-after-learn" element={<AIPage />} />
      <Route path="/machine-learning-courses-pay-after-learn" element={<MLPage />} />
      <Route path="/data-science-courses-pay-after-learn" element={<DataSciencePage />} />
      <Route path="/best-online-courses" element={<AICoursePage />} />

      <Route
        path="/python"
        element={
          <Navigate
            to="/python-courses-pay-after-learn"
            replace
          />
        }
      />

      <Route
        path="/ai"
        element={
          <Navigate
            to="/ai-courses-pay-after-learn"
            replace
          />
        }
      />

      <Route
        path="/machine-learning"
        element={
          <Navigate
            to="/machine-learning-courses-pay-after-learn"
            replace
          />
        }
      />

      <Route
        path="/ml"
        element={
          <Navigate
            to="/machine-learning-courses-pay-after-learn"
            replace
          />
        }
      />

      <Route
        path="/data-science"
        element={
          <Navigate
            to="/data-science-courses-pay-after-learn"
            replace
          />
        }
      />

      <Route
        path="/datascience"
        element={
          <Navigate
            to="/data-science-courses-pay-after-learn"
            replace
          />
        }
      />

      <Route
        path="/courses"
        element={
          <Navigate
            to="/best-online-courses"
            replace
          />
        }
      />



      <Route
        path="/ai-ml-project-rag-retrieval-argument-generation"
        element={<RAGProjectPage />}
      />

      <Route
        path="/replace-it-help-desk-with-automated-ticketing-system-using-ai"
        element={<ITSupportAgenticAIProjectPage />}
      />

      <Route
        path="/ai-ml-project-brain-stroke-prediction-opencv-cnn"
        element={<BrainStrokePredictionProjectPage />}
      />

      <Route
        path="/ai-ml-project-image-classification-deep-learning"
        element={<ImageClassificationProjectPage />}
      />

      <Route
        path="/ai-ml-project-intelligent-manufacturing-quality-control-system"
        element={<IntelligentManufacturingQualityControlPage />}
      />



      <Route
        path="/rag"
        element={
          <Navigate
            to="/ai-ml-project-rag-retrieval-argument-generation"
            replace
          />
        }
      />

      <Route
        path="/ai-rag"
        element={
          <Navigate
            to="/ai-ml-project-rag-retrieval-argument-generation"
            replace
          />
        }
      />

      <Route
        path="/it-support-ai"
        element={
          <Navigate
            to="/replace-it-help-desk-with-automated-ticketing-system-using-ai"
            replace
          />
        }
      />

      <Route
        path="/brain-stroke-ai"
        element={
          <Navigate
            to="/ai-ml-project-brain-stroke-prediction-opencv-cnn"
            replace
          />
        }
      />

      <Route
        path="/image-classification"
        element={
          <Navigate
            to="/ai-ml-project-image-classification-deep-learning"
            replace
          />
        }
      />

      <Route
        path="/manufacturing-ai"
        element={
          <Navigate
            to="/ai-ml-project-intelligent-manufacturing-quality-control-system"
            replace
          />
        }
      />

      <Route
        path="/tire-quality-ai"
        element={
          <Navigate
            to="/ai-ml-project-intelligent-manufacturing-quality-control-system"
            replace
          />
        }
      />


      <Route
        path="/cad-customization-courses"
        element={<CADCustomizationPage />}
      />

      <Route
        path="/cad-automation-training"
        element={<CADAutomationPage />}
      />


      <Route
        path="/cad"
        element={
          <Navigate
            to="/cad-automation-training"
            replace
          />
        }
      />

      <Route
        path="/cad-customization"
        element={
          <Navigate
            to="/cad-customization-courses"
            replace
          />
        }
      />

      <Route
        path="/cad-automation"
        element={
          <Navigate
            to="/cad-automation-training"
            replace
          />
        }
      />



      <Route
        path="/nx-open-customization-automation-training"
        element={<NXOpenCoursePage />}
      />

      <Route
        path="/catia-caa-customization-automation-training"
        element={<CatiaCAACoursePage />}
      />

      <Route
        path="/python-catia-automation-customization"
        element={<CatiaPythonCoursePage />}
      />

      <Route
        path="/creo-toolkit-customization-training"
        element={<CreoToolKitPage />}
      />

      <Route
        path="/solidworks-api-customization-automation-training"
        element={<SolidWorkAPIPage />}
      />

      <Route
        path="/autocad-api-customization-automation-online-courses"
        element={<AutoCADNetApiPage />}
      />

      <Route
        path="/autodesk-revit-api-customization-automation-course"
        element={<RevitAPIPage />}
      />

      <Route
        path="/autodesk-inventor-api-customization-automation-course"
        element={<InventorAPIPage />}
      />

      <Route
        path="/teamcenter-plm-customization-training-itk-rac-soa-awc"
        element={<TeamcenterPage />}
      />

      <Route
        path="/ptc-windchill-plm-customization-course"
        element={<WindChillPage />}
      />



      <Route
        path="/nx"
        element={
          <Navigate
            to="/nx-open-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/nxopen"
        element={
          <Navigate
            to="/nx-open-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/nx-open"
        element={
          <Navigate
            to="/nx-open-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/catia"
        element={
          <Navigate
            to="/catia-caa-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/catia-caa"
        element={
          <Navigate
            to="/catia-caa-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/catia-caa-api"
        element={
          <Navigate
            to="/catia-caa-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/catia-python"
        element={
          <Navigate
            to="/python-catia-automation-customization"
            replace
          />
        }
      />

      <Route
        path="/python-catia"
        element={
          <Navigate
            to="/python-catia-automation-customization"
            replace
          />
        }
      />

      <Route
        path="/creo"
        element={
          <Navigate
            to="/creo-toolkit-customization-training"
            replace
          />
        }
      />

      <Route
        path="/creo-toolkit"
        element={
          <Navigate
            to="/creo-toolkit-customization-training"
            replace
          />
        }
      />

      <Route
        path="/solidworks"
        element={
          <Navigate
            to="/solidworks-api-customization-automation-training"
            replace
          />
        }
      />

      <Route
        path="/solidworks-api"
        element={
          <Navigate
            to="/solidworks-api-customization-automation-training"
            replace
          />
        }
      />


      <Route
        path="/autocad"
        element={
          <Navigate
            to="/autocad-api-customization-automation-online-courses"
            replace
          />
        }
      />

      <Route
        path="/autocad-api"
        element={
          <Navigate
            to="/autocad-api-customization-automation-online-courses"
            replace
          />
        }
      />


      <Route
        path="/revit"
        element={
          <Navigate
            to="/autodesk-revit-api-customization-automation-course"
            replace
          />
        }
      />

      <Route
        path="/revit-api"
        element={
          <Navigate
            to="/autodesk-revit-api-customization-automation-course"
            replace
          />
        }
      />


      <Route
        path="/inventor"
        element={
          <Navigate
            to="/autodesk-inventor-api-customization-automation-course"
            replace
          />
        }
      />

      <Route
        path="/inventor-api"
        element={
          <Navigate
            to="/autodesk-inventor-api-customization-automation-course"
            replace
          />
        }
      />
      <Route
        path="/teamcenter"
        element={
          <Navigate
            to="/teamcenter-plm-customization-training-itk-rac-soa-awc"
            replace
          />
        }
      />

      <Route
        path="/teamcenter-plm"
        element={
          <Navigate
            to="/teamcenter-plm-customization-training-itk-rac-soa-awc"
            replace
          />
        }
      />


      <Route
        path="/windchill"
        element={
          <Navigate
            to="/ptc-windchill-plm-customization-course"
            replace
          />
        }
      />

      <Route
        path="/windchill-plm"
        element={
          <Navigate
            to="/ptc-windchill-plm-customization-course"
            replace
          />
        }
      />


    </Routes>
  );
}

export default AppRoutes;